import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {BranchOverview} from '../BranchOverview/BranchOverview';
import {BranchesList} from './components/BranchesList';

const UserSettingsPage = () => {
  if (isFeatureEnabled(featureFlags.TENANT_V2)) {
    return <BranchOverview />;
  }

  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.branch.labels.branches')}}
      data-testid="branches-settings-modal"
    >
      <BranchesList />
    </SettingsTemplate>
  );
};

export const Branches = UserSettingsPage;
